import { createWrapper } from './wrapper/index';
export function createAPNTagWrapper(window, member, keywords) {
    if (window.__ark_apntag)
        return window.__ark_apntag;
    window.__ark_apntag = createWrapper(window, member, keywords);
    return window.__ark_apntag;
}
